import {Component, Vue} from 'vue-property-decorator'

import {menuBtn} from '@/utils/menu_level2_button'
import {delNullProperty} from "@/utils/index";

import {
    exportStudentData,
    getClassesCustomer,
    getClassesDate,
    sendOutput,
    setCustomerListFinishByClassId
} from "@/api/classManage";
import {File} from "@/views/customer/customer-transfrom/edit-customer-info/interface";
import moment from "moment/moment";
import CommonData from "@/utils/commonData";
import {makeUploadSignature} from "@/utils/uploadMd5";
import {formatDate} from "@/utils/timeFilter";


@Component({})
export default class ClassStudent extends Vue {
    tableHeadFilter = {
        grade: '',
        customerName: '',
        prevMarketCooperationName: '',
        dissertationType: '',
        isCredit: '',
        learningOutput: '',
        publicationOutput: ''
    }
    backMoneyStatus = []
    loading = false
    tableData = []
    total = 0
    classId: number = undefined
    exportButtonDisabled = false
    exportHeaderDialogVisible = false
    tableHeader = [
        { id: 1, filds: 'customerName', cnFilds: '姓名', isShow: true },
        { id: 2, filds: 'gender', cnFilds: '性别', isShow: true },
        { id: 3, filds: 'eduCode', cnFilds: '客户识别号', isShow: true },
        { id: 4, filds: 'prevMarketCooperationName', cnFilds: '上级合作伙伴', isShow: true },
        { id: 5, filds: 'attendSchool', cnFilds: '学校', isShow: true },
        { id: 6, filds: 'grade', cnFilds: '年级', isShow: true },
        { id: 7, filds: 'specialized', cnFilds: '专业', isShow: true },
        { id: 8, filds: 'dissertationType', cnFilds: '论文服务', isShow: true },
        { id: 9, filds: 'haveIPQ', cnFilds: 'IEPQ服务', isShow: true },
        { id: 10, filds: 'ipqSubject', cnFilds: 'IEPQ学科方向', isShow: true },
        { id: 11, filds: 'isCredit', cnFilds: 'Laser证书', isShow: true },
        { id: 12, filds: 'caseStatus', cnFilds: '转案状态', isShow: true },
        { id: 13, filds: 'directorUserRealName', cnFilds: '订单负责人', isShow: true },
        { id: 14, filds: 'directorDepartmentlName', cnFilds: '订单负责人所属部门', isShow: true },
        { id: 15, filds: 'financeBackMoneyStatus', cnFilds: '回款状态', isShow: true },
        { id: 16, filds: 'isHaveOutput', cnFilds: '未回款发放产出', isShow: true },
        { id: 17, filds: 'isHaveApplication', cnFilds: '未回款开启网申', isShow: true },
        { id: 18, filds: 'customerRemark', cnFilds: '客户备注', isShow: true },
        { id: 19, filds: 'remark', cnFilds: '订单备注', isShow: true },
        { id: 20, filds: 'createdAt', cnFilds: '创建时间', isShow: true },
        { id: 21, filds: 'parentPhone', cnFilds: '家长电话', isShow: true },
        { id: 22, filds: 'email', cnFilds: '邮箱', isShow: true },
        { id: 23, filds: 'weChat', cnFilds: '微信', isShow: true },
        { id: 24, filds: 'phone', cnFilds: '手机号', isShow: true },
        { id: 25, filds: 'finishAt', cnFilds: '服务完成时间', isShow: true },
        { id: 26, filds: 'haveApply', cnFilds: '网申资格', isShow: true },
        { id: 27, filds: 'registeredCourse', cnFilds: '报名的科研课题', isShow: true },
        { id: 28, filds: 'applyCount', cnFilds: '网申推荐数量', isShow: true },
        { id: 29, filds: 'outputCount', cnFilds: '产出记录', isShow: true },
        { id: 30, filds: 'warningCount', cnFilds: '预警记录', isShow: true },
        { id: 31, filds: 'learningOutput', cnFilds: '发送科研产出', isShow: true },
        { id: 32, filds: 'publicationOutput', cnFilds: '发送论文产出', isShow: true },
    ]

    timer = null
    createdAt = ''
    page = 1
    limit = 20
    gradeOptions = CommonData.gradeList
    dissertationTypeOptions = [
        '无',
        '国外独立一作',
        '国外共同一作',
        '中文独立一作',
        'CNKI英文独立一作'
    ]
    financeOrderIdList: any = []
    serviceDialog = false
    fileList = []
    previewPath = ''
    previewName = ''
    previewVisible = false
    isshowParentPhone = true
    isshowPhone = true
    isshowWeChat = true
    isshowEmail = true
    isshowPrevMarketCooperationName = true
    isshowEduCode = true
    serviceCompleteId = ''
    produceDialog = false
    checkedDataList = []
    serviceDialogLoading = false
    uploadData = {bucket: 'crm', signature: ''}
    limitMonth = null // 接口返回的限制月份
    limitYear = null
    disabledloading = false
    lockMonth = null
    pickerOptions = {
        disabledDate: (time) => {
            return false
        }
    }
    finishAt = ''

    buttonShow = menuBtn

    get baseUrl() {
        let str = '/fileApi/upload/upload'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
            }
        }
        return str
    }

    created() {
        this.classId = Number(this.$route.query.id)  //跳转报名学员id
        this.getClassesCustomer()  //报名学员
        this.getTime()
    }

    beforeUpload (file) {
        // 1. 为当前文件实时生成专属 signature，并同步更新全局 uploadData
        const currentSignature = makeUploadSignature('crm', file.name);
        // this.uploadData.signature = currentSignature; // 同步更新，立即生效
        this.$set(this.uploadData, 'signature', currentSignature);
    }

    fileExtension(type: any) {
        if (type) {
            return type.substring(type.lastIndexOf('.') + 1)
        }
    }


    getRowKeys(row: any) {
        return row.id
    }


    selectHandle(row) {
        // if (row.finishAt) {
        //     return false
        // }  //移除批量产出发送 复原批量服务完成逻辑
        return true // 满足条件一定记得返true, 不然全都会禁选
        //     批量服务完成+批量签署合同 为了权限都正常 打开
    }


    // 报名学员
    async getClassesCustomer() {
        const backMoneyStatusStr = this.backMoneyStatus.join(',')
        this.loading = true
        await getClassesCustomer(String(this.classId), delNullProperty({
            grade: this.tableHeadFilter.grade,
            customerName: this.tableHeadFilter.customerName,
            prevMarketCooperationName: this.tableHeadFilter.prevMarketCooperationName,
            dissertationType: this.tableHeadFilter.dissertationType,
            backMoneyStatusStr: backMoneyStatusStr,
            isCredit: this.tableHeadFilter.isCredit,
            learningOutput: this.tableHeadFilter.learningOutput,
            publicationOutput: this.tableHeadFilter.publicationOutput,
            finishAt: this.finishAt && this.finishAt.length > 1 ? formatDate('yyyy-MM-dd', new Date(this.finishAt[0])) + '&' + formatDate('yyyy-MM-dd', new Date(this.finishAt[1])) : '',
            limit: this.limit,
            page: this.page,
        })).then((data: any) => {
            this.tableData = data.classesCustomerList
            this.total = data.allNum
            // this.$nextTick(() => {
            //     if (this.$refs.multipleTable) {
            //         (this.$refs.multipleTable as HTMLFormElement).doLayout();
            //         (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
            //     }
            // });
            this.loading = false
        }).catch(err => {
            this.loading = false
        })
    }

    // 导出
    async exportData(keys: string = '') {
        const backMoneyStatusStr = this.backMoneyStatus.join(',')
        this.exportButtonDisabled = true
        exportStudentData(String(this.classId), delNullProperty({
            ...this.tableHeadFilter,
            backMoneyStatusStr: backMoneyStatusStr,
            finishAt: this.finishAt && this.finishAt.length > 1 ? formatDate('yyyy-MM-dd', new Date(this.finishAt[0])) + '&' + formatDate('yyyy-MM-dd', new Date(this.finishAt[1])) : '',
            keys,
        })).then(() => {
            this.exportButtonDisabled = false
            this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        }).catch(() => [
            this.exportButtonDisabled = false
        ])
    }

    handleSelectionChange(arr: any) {
        this.checkedDataList = arr
        this.financeOrderIdList = arr.map(item => item.id)
    }

    AllService() {
        this.serviceDialog = true
    }

    // 服务完成
    handleServiceComplete(row) {
        // this.financeOrderIdList = [row.id]
        this.serviceCompleteId = row.id
        this.serviceDialog = true
        this.createdAt = null // 清空服务完成时间
    }

    returnSignContract(row) {
        const baseUrl = `${window.location.origin}/financialCenter/contractAddAgent`;
        const params = new URLSearchParams({
            isClassStudent: 'true',
            customerCode: row.eduCode,
            customerName:row.customerName,
            customerId: row.customerId,
            customerType: row.customerType,
            customerSourceType: row.customerSourceType,
            customerSource: encodeURIComponent(row.customerSource || ''),
            marketCooperationId: row.marketCooperationId,
            directorUserId: row.directorUserId,
            directorUserRealName: row.directorUserRealName,
            directorUserPhone: row.directorUserPhone,
            directorDepartmentlName: row.directorDepartmentlName
        });

        window.open(`${baseUrl}?${params.toString()}`, '_blank');
    }

    /*限制上传一个*/
    handleChange (file, fileList) {
        this.fileList = fileList.slice(-1);
    }

    uploadSuccess(response, file, fileList) {
        if (fileList.every(item => item.status == 'success')) {
            this.fileList = fileList.map(item => {
                if (item.status == 'success') {
                    return {
                        name: item.name,
                        url: item.url ? item.url : item.response.data.ossUrl
                    }
                }
            });
            this.$message.success('上传成功')
            // 手动触发 Vue 更新
            this.$forceUpdate();
        }
    }

    uploadError() {
        this.$message.error('上传失败')
    }

    handleUploadRemove(file) {
        this.fileList = this.fileList.filter(item => item.uid !== file.uid)
    }

    handleRemove(file, fileList) {
        this.fileList = fileList.map((item: File) => ({name: item.name, url: item.url}))
    }

    handlePreview(file) {
        this.previewPath = file.url
        this.previewName = file.name
        this.previewVisible = true
    }

    // 上传附件确定事件
    async clickServiceDialogConfirmButton() {
        if (!this.createdAt) {
            this.$message.error('请选择服务完成时间');
            return
        }
        this.serviceDialogLoading = true

        const obj = {
            id: this.classId,
            financeOrderIdList: this.serviceCompleteId ? [this.serviceCompleteId] : this.financeOrderIdList,
            url: this.fileList.length > 0 ? this.fileList[0].url : '',
            createdAt: moment(this.createdAt).format('YYYY-MM-DD')
        }
        const data = await setCustomerListFinishByClassId(delNullProperty(obj)).then(data => {
            this.serviceDialogLoading = false
            this.getClassesCustomer()  //报名学员
            this.$message.success('服务完成')
            this.fileList = []
            this.financeOrderIdList = []
            this.serviceCompleteId = ''
            this.createdAt = null;
            (this.$refs.multipleTable as HTMLFormElement).clearSelection();
            this.serviceDialog = false
        }).catch(err => {
            this.serviceDialogLoading = false
        })
    }

    isshow(row) {
        if (row.parentPhone === undefined) {
            this.isshowParentPhone = false
        }
        if (row.phone === undefined) {
            this.isshowPhone = false
        }
        if (row.email === undefined) {
            this.isshowEmail = false
        }
        if (row.weChat === undefined) {
            this.isshowWeChat = false
        }
        if (row.prevMarketCooperationName === undefined) {
            this.isshowPrevMarketCooperationName = false
        }
        if (row.eduCode === undefined) {
            this.isshowEduCode = false
        }
        return true;
    }

    // 查看附件
    handleCheckAttachment(url) {
        window.open(url, '_blank')
    }


    // 跳转新建回款
    returnBackMoney(row) {
        window.open(window.location.origin + '/financialCenter/newBackMoneyStudent?orderId=' + row.id + '&isFrom=1', '_blank')
    }


    handleSizeChange(val: number) {
        this.limit = val
        this.getClassesCustomer()
    }

    handleCurrentChange(val: number) {
        this.page = val
        this.getClassesCustomer()
    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getClassesCustomer()
        }, 1000)
    }

    /*跳转产出*/
    returnProduce(row) {
        const isFinish = row.finishAt ? true : false
        /*回款状态【未回款||部分回款】&& 未回款发放产出是【否】，点产出发送的时候，弹二次弹框确认【该学生卡产出，请确认】（红色字体），只提醒，可关闭，关闭之后可发送 */
        const isPrompt = (row.financeBackMoneyStatus === '未回款' || row.financeBackMoneyStatus === '部分回款') && row.isHaveOutput === '否'
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/AddClassStudentProduce?classId=' + this.classId + '&financeOrderId=' + row.id + '&isFinish=' + isFinish + '&isPrompt=' + isPrompt, "_blank")
        const time = setInterval(() => {
            if (win.closed) {
                this.getClassesCustomer()
                clearInterval(time)
            }
        }, 500)
    }

    AllProduce() {
        this.produceDialog = true
    }

    // 批量操作产出
    clickProduceDialogConfirmButton() {
        if (this.financeOrderIdList.length == 0) {
            this.$message.error('请选择要操作的学员')
            return
        }
        sendOutput(String(this.classId), {
            financeOrderIdList: this.financeOrderIdList,
        }).then(() => {
            this.$message.success('操作成功')
            this.produceDialog = false
        })
    }

    openProduceRecord(row) {
        const isFinish = row.finishAt ? true : false
        /*回款状态【未回款||部分回款】&& 未回款发放产出是【否】，点产出发送的时候，弹二次弹框确认【该学生卡产出，请确认】（红色字体），只提醒，可关闭，关闭之后可发送 */
        const isPrompt = (row.financeBackMoneyStatus === '未回款' || row.financeBackMoneyStatus === '部分回款') && row.isHaveOutput === '否'
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/ClassStudentProduceRecord?classesId=' + this.classId + '&financeOrderId=' + row.id + '&isFinish=' + isFinish +'&isPrompt='+ isPrompt, "_blank")
        const time = setInterval(() => {
            if (win.closed) {
                clearInterval(time)
            }
        }, 500)
    }

    /*预警记录*/
    openWarningRecord(row) {
        const isFinish = row.finishAt ? true : false
        /*回款状态【未回款||部分回款】&& 未回款发放产出是【否】，点产出发送的时候，弹二次弹框确认【该学生卡产出，请确认】（红色字体），只提醒，可关闭，关闭之后可发送 */
        const isPrompt = (row.financeBackMoneyStatus === '未回款' || row.financeBackMoneyStatus === '部分回款') && row.isHaveOutput === '否'
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/ClassStudentWarningRecord?classesId=' + this.classId + '&financeOrderId=' + row.id + '&isFinish=' + isFinish +'&isPrompt='+ isPrompt, "_blank")
        const time = setInterval(() => {
            if (win.closed) {
                clearInterval(time)
            }
        }, 500)
    }


    handleBatchSignContract() {
        /*判断每一条数据是否都包含customerContractObj对象
        * 从工具导入的数据可以批量签署，正常录入的不支持*/
        if (this.checkedDataList.every(item => item.customerContractObj)) {
            const data = this.checkedDataList.map((item => {
                return {
                    customerName: item.customerName,
                    customerId: item.customerId,
                    customerType: item.customerType,
                    customerSourceType: item.customerSourceType,
                    customerSource: item.customerSource,
                    marketCooperationId: item.marketCooperationId,
                    directorUserId: item.directorUserId,
                    directorUserRealName: item.directorUserRealName,
                    directorUserPhone: item.directorUserPhone,
                    custodianIdCard: item.customerContractObj.custodianIdCard,
                    custodianName: item.customerContractObj.custodianName,
                    custodianPhone: item.customerContractObj.custodianPhone,
                    idCard: item.customerContractObj.idCard,
                    isAdult: item.customerContractObj.isAdult,
                    psnAccount: item.customerContractObj.psnAccount,
                    directorDepartmentlName: item.directorDepartmentlName
                }
            }))

            /*本地存储数据*/
            localStorage.setItem('batchSignInfoData', JSON.stringify(data))
            window.open(window.location.origin + '/financialCenter/contractAddAgent?batchSign=true')

        } else {
            this.$message.error('选中的学生中有部分缺失合同信息数据，请补充再进行批量签署操作！')
        }
    }


    getTime() {
        this.disabledloading = true
        // 如果是null ，则可以选任意时间；如果是2025-3，则可以选2025-3之后的时间
        getClassesDate().then((res: any) => {
            this.lockMonth = res.date
            if (this.lockMonth === null) {
                this.limitYear = null;
                this.limitMonth = null;
                this.disabledloading = false;
                return;
            }
            // 解析 '2025-01' 为年份和月份（核心适配点）
            const [year, month] = res.date.lockMonth.split('-');
            this.limitYear = Number(year);   // 2025
            this.limitMonth = Number(month); // 1
            this.disabledloading = false
            this.updatePickerOptions();
        }).catch(() => {
            this.disabledloading = false
        }).finally(() => {
            this.disabledloading = false; // 无论成功/失败，都结束加载
        })

    }
    // 专门更新pickerOptions的方法
    updatePickerOptions() {
        // 重新赋值pickerOptions，触发响应式更新
        this.pickerOptions = {
            disabledDate: (time) => {
                // 校验参数是否有效，避免NaN导致的逻辑错误
                if (!this.limitYear || !this.limitMonth) {
                    return false;
                }
                // 注意：new Date(年, 月-1, 1) 是正确的日期构造方式（月份从0开始）
                // 比如要限制2025-03之后才能选，就禁用2025-03-01之前的日期
                const limitDate = new Date(this.limitYear, this.limitMonth, 1);
                return time.getTime() < limitDate.getTime();
            }
        };
    }


}
